//GLOBAL - components from npm
import React from "react";

//STYLES
import "./h2.css";

//COMPONENTS

//SERVICES - api, conectors...

//GLOBAL STATE - redux, env...

//ASSETS - icons, images...

export default function H2({ className, children, weight, color }) {
  //GENERAL
  const mainClassName = "typography-h2";

  //STATES

  //REDUX - Selectors

  //FUNCTIONS

  //USE EFFECTS

  return (
    <h2
      className={`${mainClassName} ${className ? className : ""} ${
        weight ? `${mainClassName}--${weight}` : ""
      } ${color ? `${mainClassName}--color-${color}` : ""}`}
    >
      {children}
    </h2>
  );
}
